<template>
    <TinyBlock
        :elevation="elevation"
        :tooltip="tooltip"
        @click="handleClick"
    >
        <slot name="content">
            <StatContent
                :title="title"
                :icon="icon"
                :size="size"
                :stat="stat"
                :subtitle="subtitle"
                :secondary-value="secondaryValue"
                :secondary-above="secondaryAbove"
                :secondary-format="secondaryFormat"
                :format="format"
                :loading="loading"
                :subtitle-color="subtitleColor"
                :variant="variant"
                :icon-shadow-only="iconShadowOnly"
                :value-suffix="valueSuffix"
                :warning="warning"
                :warning-active="warningActive"
                :warning-label="warningLabel"
                @warning-click="$emit('warning-click', $event)"
            />
        </slot>
    </TinyBlock>
</template>

<script>
import GlobalMixins from "@/mixins/global";
import StatContent from "./stat-content.vue";
import TinyBlock from "./tiny-block.vue";

export default {
    name: "Stat",
    mixins: [GlobalMixins],
    components: {
        StatContent,
        TinyBlock,
    },
    props: {
        size: {
            type: String,
            default: "small",
            validator: (value) => ["compact", "small", "medium", "large"].includes(value),
        },
        title: {
            type: String,
            required: true,
        },
        elevation: {
            type: [String, Number],
            default: 0,
        },
        stat: {
            type: [String, Number],
            default: null,
        },
        subtitle: {
            type: String,
            default: "",
        },
        icon: {
            type: String,
            default: null,
        },
        subtitleColor: {
            type: String,
            default: "grey",
        },
        loading: {
            type: Boolean,
            default: false,
        },
        format: {
            type: String,
            default: "number",
            validator: (value) => ["number", "euros", "string", "percent"].includes(value),
        },
        valueSuffix: {
            type: String,
            default: null,
        },
        secondaryAbove: {
            type: Boolean,
            default: false,
        },
        secondaryValue: {
            type: [String, Number],
            default: null,
        },
        unit: {
            type: String,
            required: false,
        },
        unitType: {
            type: String,
            default: "number",
            validator: (value) => ["number", "percent", "string"].includes(value),
        },
        tooltip: {
            type: String,
            default: null,
            required: false,
        },
        secondaryFormat: {
            type: String,
            default: "number",
        },
        variant: {
            type: String,
            default: "default",
            validator: (value) => ["default", "create"].includes(value),
        },
        iconShadowOnly: {
            type: Boolean,
            default: false,
        },
        warning: {
            type: Boolean,
            default: false,
        },
        warningActive: {
            type: Boolean,
            default: false,
        },
        warningLabel: {
            type: String,
            default: null,
        },
    },
    methods: {
        handleClick(event) {
            this.$emit("click", event);
        },
        formatString(value) {
            if (value === null || value === undefined) {
                return "-";
            }
            if (this.format === "string") {
                return value;
            }
            if (this.format === "euros") {
                return this.$utils.price(value);
            }
            if (this.format === "percent") {
                return this.$utils.percent(value);
            }
            if (this.unitType) {
                return value;
            }
            if (this.unit) {
                return this.$utils.formatNumberToString(value) + (this.unit ? ` ${this.unit}` : "");
            }
            return this.$utils.formatNumberToString(value);
        },
    },
};
</script>

